<template>
  <mu-dialog :open='isShow'>
      <div style="background-color:#838383;position:fixed;top:0;left:0;width:100%;height:100%;">
      <div style="color:#000;background-color:F2F2F2;position:fixed;z-index:10;top:10px;left:20%;" @click="close()">关闭</div>
      <iframe  class="game-iframe" name="openGames" :src="gameUrl" scrolling="no" ></iframe>
      </div>
  </mu-dialog>
</template>

<script>
export default ({
    props:['gameData'],
    data() {
      return{
          gameUrl:"",
          isShow:true
      }
    },
    created(){
    //   this.gameUrl = GLOBAL.verbal_cognition+"/game3/"+this.gameData.gindex+"/"+this.gameData.gindex+".html?embed=false";
      this.gameUrl = GLOBAL.verbal_cognition+"/"+this.gameData.proto;
    //   this.gameUrl = "http://localhost"+"/"+this.gameData.proto;
    },
    computed:{
      
    },
    methods: {
        decision(){
            let self = this;
            window.addEventListener('message', function (event) {
                switch(event.data.action){
                    case 'endGame':
                        console.log(event);
                        self.isShow=false;
                        self.$emit('verbalEvent');
                        break;
                    default:
                        break;
                }
            })
        },
        close(){
            this.$emit('verbalEvent');
        }
    },
    mounted(){
        this.decision();
    }
})
</script>

<style scoped>
iframe{
    width:100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// verbalGames.vue?38cc3f86